import i18n from "./i18n";

/**
 * Datum und Uhrzeit in der Sprache der Anwendung.
 *
 * Bis hierher stand an neun Stellen `toLocaleDateString(undefined, ...)`. Das
 * "undefined" heisst: nimm die Sprache des Browsers. Die hat mit der Sprache
 * der Anwendung aber nichts zu tun. Ein Mitarbeiter mit spanischem Telefon
 * las im deutschen Backoffice "mar, 01/09/2026", und wer die Anwendung auf
 * Englisch stellte, bekam trotzdem deutsche Monatsnamen, sobald sein Geraet
 * deutsch war.
 *
 * Die Anwendung hat eine eigene Sprachwahl, oben rechts. Was darin steht,
 * gilt: der Kalender ist Teil der Uebersetzung, nicht Teil des Geraets.
 *
 * Die Zeitzone bleibt bewusst die des Geraets. Wer auf Mallorca sitzt, hat
 * Madrid eingestellt, und wer von Deutschland aus in den Dienstplan sieht,
 * soll dieselbe Uhrzeit lesen wie der Mitarbeiter vor Ort.
 */

/** Die eingestellte Sprache, nicht die des Browsers. */
export function sprache(): string {
  return i18n.language || "de";
}

/**
 * Der heutige Tag als 2026-08-23, gemessen auf Mallorca.
 *
 * Bewusst nicht in der Zeitzone des Geraets: ein Buero in Deutschland sieht um
 * Mitternacht sonst schon den naechsten Tag, waehrend auf der Insel noch der
 * alte laeuft. Der Arbeitstag ist der auf Mallorca, sonst landen Belege und
 * Dienste im falschen Datum.
 */
export function heute(): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Madrid" }).format(new Date());
}

/** 08:15 */
export function alsUhrzeit(iso: string): string {
  return new Date(iso).toLocaleTimeString(sprache(), { hour: "2-digit", minute: "2-digit" });
}

/** 07.09., 08:15 */
export function alsDatumUndZeit(iso: string): string {
  return new Date(iso).toLocaleString(sprache(), {
    day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit"
  });
}

/**
 * Minuten als Stundenangabe: "3,5 h".
 *
 * Gerechnet wird in Minuten, gelesen wird in Stunden. "210 min Garten" muss
 * jeder im Kopf teilen, und das Komma gehoert in die Sprache der Anwendung:
 * auf Deutsch 3,5 und auf Englisch 3.5.
 */
export function alsStunden(minuten: number): string {
  const wert = minuten / 60;
  return `${wert.toLocaleString(sprache(), { maximumFractionDigits: 2 })} h`;
}
